export default __webpack_public_path__ + "static/media/spam_detector.99fba432.PNG";